import { AUTH_STATE_ENUM } from "constant/auth";
import useAuth from "hooks/useAuth";
import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { Toaster } from "react-hot-toast";
import { useLocation, useNavigate } from "react-router-dom";
import Footer from "../Footer/Footer";
import Navbar from "../Navbar/Navbar";
import ReactGA from "react-ga4";
import MenuMobile from "components/Navbar/MenuMobile";
import useAppStore from "store/useAppStore";

const AppLayout = ({ children, authState = AUTH_STATE_ENUM.PUBLIC, title }) => {
  const { isAuth, isLoadAuth } = useAuth();
  const { name } = useAppStore();

  const [showMenuMobile, setShowMenuMobile] = useState(false);
  const [isLoadAuthState, setIsLoadAuthState] = useState(true);
  const navigate = useNavigate();
  const location = useLocation();
  const pathname = location?.pathname;
  const titleLabel = title
    ? `${title} | Weekend Career Expo`
    : "Weekend Career Expo";

  try {
    ReactGA.initialize(process.env.REACT_APP_TRACKING_ID);
  } catch (e) {
    console.log(e);
  }

  useEffect(() => {
    ReactGA.send({
      hitType: "pageview",
      page: pathname,
      title: titleLabel,
    });
  }, [pathname, titleLabel]);

  useEffect(() => {
    if (!isLoadAuth) {
      if (
        (authState === AUTH_STATE_ENUM.LOGIN && !isAuth) ||
        (authState === AUTH_STATE_ENUM.NON_LOGIN && isAuth)
      ) {
        navigate("/");
      } else {
        setIsLoadAuthState(false);
      }
    }
  }, [authState, isLoadAuth, isAuth, navigate]);

  return (
    <div className="flex flex-col min-h-screen">
      <Helmet>
        <title>{titleLabel}</title>
      </Helmet>
      <MenuMobile
        showMenuMobile={showMenuMobile}
        handleClose={() => setShowMenuMobile(false)}
      />
      <Navbar
        location={location}
        isAuth={isAuth}
        isLoadAuth={isLoadAuth}
        name={name}
        handleShow={() => setShowMenuMobile(true)}
      />
      <Toaster
        position="top-center"
        containerClassName="mt-18"
        toastOptions={{
          className: "max-w-[50%]",
        }}
      />
      <div className="flex flex-1 relative">
        {isLoadAuth || (isLoadAuthState && authState !== AUTH_STATE_ENUM.PUBLIC)
          ? ""
          : children}
      </div>
      <Footer />
    </div>
  );
};

export default AppLayout;
